import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HeaderComponent, HeaderConfigModel } from '@shared/components/header/header.component';
import { AchievementService } from '../../services/achievement.service';
import { AchievementsModel } from '../../models/achievements-model';
import { switchMap } from 'rxjs/operators';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { AchievementAggregatorService } from '../../services/achievement-aggregator.service';
import { NextAchievementStepModel } from '../../models/next-achievement-step-model';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { BaseComponent } from '@shared/components/base/base.component';
import { EImageType } from '@shared/pipes/image.pipe';
import { SharedModule } from '@shared/module/shared.module';
import { ProgressWidthPipe } from '@shared/pipes/progress-width/progress-width.pipe';

@Component({
    selector: 'app-achievements',
    imports: [
        SharedModule,
        HeaderComponent,
        ProgressWidthPipe,
        NgxSkeletonLoaderModule,
    ],
    templateUrl: './achievements.component.html',
    styleUrls: ['./achievements.component.scss']
})
export class AchievementsComponent extends BaseComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private achievementService = inject(AchievementService);
  private achievementAggregatorService = inject(AchievementAggregatorService);


  headerConfig: HeaderConfigModel = {
    title: 'دستاوردها',
    hasAction: false,
    actionList: []
  };

  id!: string;
  termFilterAllAchievements: TermFilterModel = new TermFilterModel(0, 100);
  allAchievements!: AchievementsModel[];
  nextAchievementStep: NextAchievementStepModel = new NextAchievementStepModel();
  achievementsCombined: any[] = [];

  loadingNextAchievement = true;
  loadingAllAchievements = true;

  progressBarStep!: number;
  progressBarTotalStep!: number;

  profileOwner!: boolean;

  imageType = EImageType;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.activatedRoute.params.pipe(
      switchMap(params => {
        this.id = params['id'];
        return this.getAchievements();
      }),
      switchMap(res => {
        if (!res.hasError) {
          this.loadingAllAchievements = false;
          this.allAchievements = res.result?.items;
        }
        return this.getMyNextAchievementStep();
      })
    ).subscribe(res => {
      if (!res.hasError) {
        this.loadingNextAchievement = false;
        this.nextAchievementStep = res.result;
        this.progressBarStep = this.nextAchievementStep.nextAchievementStep - this.nextAchievementStep.lastAchievedStep - this.nextAchievementStep.remainingAchievementBooks;
        this.progressBarTotalStep = this.nextAchievementStep?.nextAchievementStep - this.nextAchievementStep?.lastAchievedStep;
        this.checkProfileOwner();
      }
    });

  }

  checkProfileOwner() {
    if (this.currentUser && (this.id == this.currentUser?.id)) {
      this.profileOwner = true;
    }
  }

  getAchievements() {
    return this.achievementService.getGuestAchievements(this.id, this.termFilterAllAchievements);
  }

  getMyNextAchievementStep() {
    if (this.id === this.currentUser?.id!) {
      return this.achievementAggregatorService.getMyNextAchievementStep();
    }
    else {
      return this.achievementAggregatorService.getGuestNextAchievementStep(this.id);
    }
  }
}
